export const PARTNER_CONSTS = {
    SET_PARTNERS_DATA:"SET_PARTNERS_DATA",
    CREATE_PARTNER_ITEM:"CREATE_PARTNER_ITEM",
    UPDATE_PARTNER_ITEM: "UPDATE_PARTNER_ITEM",
    DELETE_PARTNER_ITEM: "DELETE_PARTNER_ITEM",
    UPDATE_PARTNERS_POSITIONS: "UPDATE_PARTNERS_POSITIONS",
};
